import { useSessionContext } from 'supertokens-auth-react/recipe/session';

import usePayload from './usePayload';

const useGetUserSession = () => {
  const { jwt } = usePayload();
  const session = useSessionContext();

  const sessionLoading = !session || session.loading;
  const userId = !sessionLoading ? session.userId : '';
  const sessionExist = !sessionLoading ? session.doesSessionExist : undefined;
  const userIsSignedIn = Boolean(jwt && userId && sessionExist);
  const sessionHandle = !sessionLoading
    ? session.accessTokenPayload.sessionHandle
    : '';

  return {
    session,
    sessionExist,
    sessionHandle,
    sessionLoading,
    userId,
    userIsSignedIn,
  };
};

export default useGetUserSession;
